export enum NotificationMessageStatus {
    Unknown = 0,
    Open = 1,
    Done = 2,
}
